import { render, staticRenderFns } from "./RightMenuFirstTimeFreeUpload_Ap.vue?vue&type=template&id=68a222a0&scoped=true"
import script from "./RightMenuFirstTimeFreeUpload_Ap.vue?vue&type=script&lang=js"
export * from "./RightMenuFirstTimeFreeUpload_Ap.vue?vue&type=script&lang=js"
import style0 from "./RightMenuFirstTimeFreeUpload_Ap.vue?vue&type=style&index=0&id=68a222a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a222a0",
  null
  
)

export default component.exports